<template>
  <div class="field">
    <label v-if="label" class="label">{{ label }}</label>
    <div class="control">
      <div class="select">
        <select @change="updateValue">
          <option v-if="emptyValueSelectable" :selected="value === valueOnEmpty" :value="valueOnEmpty">{{ emptyValueText || ' -- Empty -- '}}</option>
          <option v-else disabled selected hidden :value="valueOnEmpty">{{ emptyValueText || ' -- select an option -- '}}</option>
          <option v-for="(option, index) in options" :key="option+index" :value="getSelectOptionValue(option)" :selected="isSelected(option)">{{ getDisplayName(option) }}</option>
        </select>
      </div>
    </div>

  </div>
</template>

<script>
import selectMixin from './selectMixin'
export default {
  name: 'select-single',
  mixins: [selectMixin],
  props: {
    value: {},
    options: { type: Array, required: true },
    label: { type: String },
    displayKey: { type: String },
    valueKey: { type: String },
    uniqueIdKey: { type: String },
    valueOnEmpty: { default: null },
    emptyValueSelectable: { type: Boolean, default: false },
    emptyValueText: { type: String }
  },
  methods: {
    /**
     * Select update value
     * Update value functino for single select (not multi)
     * @param {Object} event - select input object
     */
    updateValue(event) {
      let value
      value = event.target.value || event.srcElement.value

      // try t parse for json object
      try {
        value = JSON.parse(value)
      } catch (err) {}

      if (value === '') value = this.valueOnEmpty

      this.$emit('input', value)
    }
  }
}
</script>


<style lang="scss" scoped>
.select select {
  width: 100%;
}
</style>
